import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Page, RowButton } from '../styles';
import { StepSeatsAside } from '../StepSeats/styles';
import { Button } from 'app/components';
import { useTranslation } from 'react-i18next';
import SnacksDrinks from '../SnacksDrinks';
import SnacksAsideComponentContainer from '../SnacksAsideComponent';
import SnacksAsideMobileComponent from '../SnacksAsideMobileComponent';
import { StepSnacksAside } from './styles';
import PropTypes from 'prop-types';
import { generatePath } from 'react-router-dom';
import ConfigContext from 'app/context/config';
import BoxMenu from '../BoxMenu';

const propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,

  // isOrdered: PropTypes.bool.isRequired,
  movieCinemaId: PropTypes.string.isRequired,
  // sessionData: PropTypes.object.isRequired
};
const StepSnacksAndDrinks = ({ movieCinemaId, history: { push }, }) => {
  const [t] = useTranslation();
  const { routes } = useContext(ConfigContext);
  const [windowSize, setWindowSize] = useState();
  const next = useCallback(() => {
    push(generatePath(routes.stepCheckout.pattern, { movieCinemaId }));
  }, []);

  useEffect(() => {
    setWindowSize(window.innerWidth);
  }, [window]);

  window.addEventListener('resize', function () {
    setWindowSize(window.innerWidth);
  }, true);

  return (
    <>

      <Page className="_seatplan">
        <SnacksDrinks history={push} movieCinemaId={movieCinemaId} />
        {/* {
          windowSize >= 992 ?
            <StepSnacksAside>
              <SnacksAsideComponentContainer />
              <div>
                <RowButton>
                  <Button isPrimary
                    onClick={next}
                  >
                    {t('purchase.next')}
                  </Button>
                </RowButton>
              </div>
            </StepSnacksAside>
            :
            <SnacksAsideMobileComponent />} */}
      </Page>
    </>
  )
}

export default StepSnacksAndDrinks;